import { render } from "./circle.vue?vue&type=template&id=ed1aed00&scoped=true"
import script from "./circle.vue?vue&type=script&lang=js"
export * from "./circle.vue?vue&type=script&lang=js"

import "./circle.vue?vue&type=style&index=0&id=ed1aed00&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed1aed00"]])

export default __exports__